interface SavedCommTemplate {
  id?: string | number | null;
  source_ats_comm_template_id?: string | number | null;
}

/**
 * A saved activity's comm template is a server-side copy, so its `id` matches
 * nothing in the picker. Swap in the template the user actually picked, keeping
 * the copy's saved subject/body.
 */
export const withSourceTemplateId = <T extends SavedCommTemplate>(
  template?: T | null
): T | Record<string, never> => {
  if (!template) return {};
  const source = template.source_ats_comm_template_id;
  return source === undefined || source === null
    ? template
    : { ...template, id: source };
};
